export default {
  icons: [
    {
      image:
        'https://www.nerdwallet.com/cdn/component/social-media/icons/linkedin-icon.png',
      alt_text: 'LinkdIn',
      url: 'https://www.linkedin.com/company/nerdwallet',
      height: 23,
      width: 23,
      naturalHeight: 5,
      naturalWidth: 5,
    },
    {
      image:
        'https://www.nerdwallet.com/cdn/component/social-media/icons/play-icon.png',
      alt_text: 'Youtube',
      url: 'https://www.youtube.com/channel/UCTTYccSBNghxcxULTGaO1bA',
      height: 19,
      width: 28,
      naturalHeight: 19,
      naturalWidth: 28,
    },
    {
      image:
        'https://www.nerdwallet.com/cdn/component/social-media/icons/instagram-icon.png',
      alt_text: 'Instagram',
      url: 'https://www.instagram.com/nerdwallet/',
      height: 24,
      width: 24,
      naturalHeight: 24,
      naturalWidth: 24,
    },
    {
      image:
        'https://www.nerdwallet.com/cdn/component/social-media/icons/facebook-icon.png',
      alt_text: 'Facebook',
      url: 'https://www.facebook.com/NerdWallet/',
      height: 24,
      width: 12,
      naturalHeight: 24,
      naturalWidth: 12,
    },
    {
      image:
        'https://www.nerdwallet.com/cdn/component/social-media/icons/twitter-icon.png',
      alt_text: 'Twitter',
      url: 'https://twitter.com/NerdWallet',
      height: 22,
      width: 26,
      naturalHeight: 22,
      naturalWidth: 26,
    },
  ],
};
